module.exports = __webpack_public_path__ + "static/media/Resume.833b44e1.JPG";